import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { OrderModel, OrderSettingsModel } from "@insite/client-framework/Types/ApiModels";
import OrderDetailPageTypeLink from "@insite/content-library/Components/OrderDetailPageTypeLink";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
// eslint-disable-next-line spire/fenced-imports
import CustomSmallHeadingAndText from "@WhiteCap/Components/CustomSmallHeadingAndText";
// eslint-disable-next-line spire/fenced-imports
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import loadOrder from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/LoadOrder";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MultipleDeliveryStatus from "@WhiteCap/Components/MultipleDeliveryAndStatus";
import OrderDetailsKebabMenu from "@WhiteCap/Components/OrderDetailsKebabMenu";
import ProofOfDeliveryComponent from "@WhiteCap/Components/ProofOfDeliveryComponent";
import ProofOfDeliveryWillCallComponent from "@WhiteCap/Components/ProofOfDeliveryWillCallComponent";
import SmallHeadingAndTextDelivery from "@WhiteCap/Components/SmallHeadingAndTextDelivery";
import StatusLableAndHeading from "@WhiteCap/Components/StatusLableAndHeading";
import loadPODData from "@WhiteCap/Handlers/PODOrderHistory/PODHandler";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { FC, useMemo, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    language: state.context.session.language,
    isLoading: state.WhiteCap.podDataStore.isLoading,
});
const mapDispatchToProps = {
    loadPODData,
    loadOrder,
};
interface OwnProps {
    order: OrderModel;
    indexNumber: number;
    orderSettings: OrderSettingsModel;
    extendedStyles?: OrderSummaryCardStyles;
}

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface OrderSummaryCardStyles {
    orderSummaryCardGridItem?: GridItemProps;
    container?: GridContainerProps;
    pageTypeLinkGridItem?: GridItemProps;
    orderNumberGridItem?: GridItemProps;
    orderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    statusGridItem?: GridItemProps;
    statusHeadingAndText?: SmallHeadingAndTextStyles;
    deliveryrHeadingAndText?: SmallHeadingAndTextStyles;
    webOrderNumberGridItem?: GridItemProps;
    webOrderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    totalGridItem?: GridItemProps;
    totalHeadingAndText?: SmallHeadingAndTextStyles;
    orderDateHeader?: DataTableHeaderProps;
    orderNumberHeader?: DataTableHeaderProps;
    shipToHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    customerPOHeader?: DataTableHeaderProps;
    orderTotalHeader?: DataTableHeaderProps;
    reorderHeader?: DataTableHeaderProps;
    orderDateCells?: DataTableCellProps;
    orderNumberCells?: DataTableCellProps;
    shipToCells?: DataTableCellProps;
    kababMenu?: DataTableCellProps;
    statusCells?: DataTableCellProps;
    customerPOCells?: DataTableCellProps;
    orderTotalCells?: DataTableCellProps;
    reorderCells?: DataTableCellProps;
    trackButton?: ButtonPresentationProps;
    grayDash?: SmallHeadingAndTextStyles;
    fromOrderHeadingAndText?: SmallHeadingAndTextStyles;
    fromQuoterHeadingAndText?: SmallHeadingAndTextStyles;
    firstStyleWrapper?: InjectableCss;
    secondStyleWrapper?: InjectableCss;
    multipleDeliveryAndStatusWraaper?: InjectableCss;
    multipleDeliveryHeading?: TypographyPresentationProps;
    multipleLink?: LinkPresentationProps;
    orderDateHeadingAndText?: SmallHeadingAndTextStyles;
}

export const orderSummaryCardStyles: OrderSummaryCardStyles = {
    orderSummaryCardGridItem: {
        width: 12,
        css: css`
            padding: 0 20px;
            max-width: 500px;
        `,
    },
    container: { gap: 5 },
    pageTypeLinkGridItem: { width: 12 },
    orderNumberGridItem: { width: 6 },
    statusGridItem: { width: 6 },
    webOrderNumberGridItem: { width: 6 },
    totalGridItem: { width: 6 },
    kababMenu: {
        css: css`
            text-align: right;
            padding: 0px;
            width: 100%;
        `,
    },
    orderTotalCells: {
        css: css`
            width: 40%;
            padding: 0px;
            p[data-test-selector^="heading"] {
                text-align: right;
            }
            p[data-test-selector^="text_Total"] {
                text-align: right;
            }
        `,
    },
    orderNumberCells: {
        css: css`
            width: 20%;
            padding: 0 10px;
        `,
    },
    orderDateCells: {
        css: css`
            width: 20%;
            padding: 0 10px;
        `,
    },
    shipToCells: {
        css: css`
            width: 33%;
            padding: 0 6px;
        `,
    },
    firstStyleWrapper: {
        css: css`
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: flex-start;
            td {
                border-bottom: none;
            }
            border-bottom: 3px solid ${getColor("primary.contrast")};
        `,
    },
    secondStyleWrapper: {
        css: css`
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: flex-start;

            td {
                border-bottom: none;
            }
        `,
    },
    trackButton: {
        css: css`
            background-color: ${getColor("primary.contrast")};
            span {
                font-size: 14px !important;
                font-weight: 500 !important;
                padding-left: 4px;
                padding-right: 4px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding-left: 2px;
                            padding-right: 2px;
                            font-weight: 500 !important;
                            font-size: 10px !important;
                        `,
                        css`
                            padding-left: 4px;
                            padding-right: 4px;
                            font-weight: 500 !important;
                            font-size: 12px !important;
                        `,
                        css``,
                        css``,
                        css``,
                    ])}
            }
            font-size: 14px !important;
            font-weight: 500 !important;
            padding-left: 4px;
            padding-right: 4px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px !important;
                        padding-left: 2px;
                        padding-right: 2px;
                        font-weight: 500 !important;
                    `,
                    css`
                        padding-left: 4px;
                        padding-right: 4px;
                        font-weight: 500 !important;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    orderDateHeadingAndText: {
        heading: {
            css: css`
                color: ${getColor("text.main")};
                text-align: start;
                font-weight: 400;
                font-size: 14px;
            `,
        },
        text: {
            css: css`
                color: ${getColor("text.main")};
                font-size: 12px;
                font-weight: 500;
                text-align: start;
            `,
        },
    },

    deliveryrHeadingAndText: {
        heading: {
            css: css`
                min-width: 55px;
                color: ${getColor("text.main")};
                text-align: start;
                font-weight: 400;
                font-size: 14px;
            `,
        },
        text: {
            css: css`
                min-width: 55px;
                text-transform: capitalize !important;
                color: ${getColor("text.main")};
                font-size: 12px;
                font-weight: 500;
                text-align: start;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                line-height: 1.5;
                text-overflow: ellipsis;
                white-space: normal;
            `,
        },
    },
    orderNumberHeadingAndText: {
        heading: {
            css: css`
                color: ${getColor("text.main")};
                text-align: center;
                font-weight: 400;
                font-size: 14px;
            `,
        },
        text: {
            css: css`
                color: ${getColor("text.main")};
                font-size: 16px;
                text-align: center;
                font-weight: 450;
            `,
        },
    },
    fromQuoterHeadingAndText: {
        heading: {
            css: css`
                color: ${getColor("text.main")};
                text-align: start;
                font-weight: 400;
                font-size: 14px;
            `,
        },
        text: {
            css: css`
                color: ${getColor("text.main")};
                font-size: 16px;
                text-align: start;
                font-weight: 450;
            `,
        },
    },
    grayDash: {
        heading: {
            css: css`
                color: ${getColor("text.main")};
                font-weight: 400;
                font-size: 14px;
                text-align: start;
            `,
        },
        text: {
            css: css`
                color: gray;
                font-weight: bold;
                text-align: start;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-left: 30%;
                        `,
                        css`
                            margin-left: 20%;
                        `,
                        css``,
                        css``,
                        css``,
                    ])}
            `,
        },
    },
    fromOrderHeadingAndText: {
        heading: {
            css: css`
                font-weight: 400;
                font-size: 14px;
                text-align: center;
            `,
        },
        text: {
            css: css`
                color: ${getColor("text.main")};
                font-size: 16px;
                font-weight: 500;
                text-align: center;
            `,
        },
    },
    multipleDeliveryAndStatusWraaper: {
        css: css`
            flex-direction: column;
            display: flex;
            justify-content: center;
            align-items: start;
        `,
    },
    multipleDeliveryHeading: {
        css: css`
            font-size: 10px;
            text-transform: uppercase;
            font-weight: 400;
            text-align: start !important;
        `,
    },
    multipleLink: {
        typographyProps: {
            css: css`
                font-size: 12px !important;
                font-weight: 500;
                text-align: start !important;
                text-decoration: none; /* Ensure no underline */
                outline: none !important;
                border: none !important;
                box-shadow: none !important;
            `,
        },
        css: css`
            &:focus {
                outline: none;
            }
        `,
    },
};

const useTextRefs = () => {
    const deliveryTextRefs = useRef(new Map<string, React.RefObject<HTMLDivElement>>());

    // Function to get or create a ref for a specific orderNumber
    const getOrCreateRef = (orderNumber: string): React.RefObject<HTMLDivElement> => {
        const map = deliveryTextRefs.current;
        if (!map.has(orderNumber)) {
            map.set(orderNumber, React.createRef<HTMLDivElement>());
        }
        return map.get(orderNumber)!;
    };

    return {
        getOrCreateDeliveryTextRef: getOrCreateRef,
    };
};

const OrderSummaryCardMobile: FC<Props> = ({
    language,
    order,
    orderSettings,
    isLoading,
    indexNumber,
    extendedStyles,
    loadPODData,
    loadOrder,
}) => {
    const [styles] = React.useState(() => mergeToNew(orderSummaryCardStyles, extendedStyles));
    const { getOrCreateDeliveryTextRef } = useTextRefs();
    const [PODstate, setPODState] = useState({
        isModalOpen: false,
        selectedIndex: 0,
        poNumber: "",
        isWillCallPod: false,
    });
    const isTrueOrUndefined = (value?: boolean) => value === true || value === undefined;

    const trackHandler = (url: string | URL | undefined) => {
        window.open(url, "_blank");
    };

    const orderDateDisplay = getLocalizedDateTime({
        dateTime: order.orderDate,
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    const orderNumber = order.erpOrderNumber || order.webOrderNumber;
    const loadPODDataHandler = (
        id: string,
        properties: any,
        arrayindex: number,
        po: string,
        isWillCallPod: boolean,
    ) => {
        setPODState({
            isModalOpen: true,
            selectedIndex: arrayindex,
            poNumber: po,
            isWillCallPod,
        });
        if (isWillCallPod) {
            loadOrder({
                orderNumber: id,
                sTEmail: "",
                sTPostalCode: "",
            });
        }

        loadPODData({ orderNumber: id, id: properties.podId });
    };
    const closeModal = () => {
        setPODState({
            isModalOpen: false,
            selectedIndex: 0,
            poNumber: "",
            isWillCallPod: false,
        });
    };

    const [isDeliveryModalIsOpen, setIsDeliveryModalIsOpen] = useState<string | null>(null);

    const MultipleDeliveryClickHandler = (orderNumber: string) => {
        setIsDeliveryModalIsOpen(isDeliveryModalIsOpen === orderNumber ? null : orderNumber);
    };

    const closeMultipleDeliveryModal = () => {
        setIsDeliveryModalIsOpen(null);
    };

    return (
        <>
            <DataTableRow
                css={css`
                    border-bottom: 1px solid ${getColor("common.border")};
                `}
            >
                <StyledWrapper {...styles.firstStyleWrapper}>
                    {/* Order Number Cell */}
                    <DataTableCell
                        css={css`
                            width: 24%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            padding: 0 6px;
                        `}
                    >
                        {(order.erpOrderNumber || order.webOrderNumber) && (
                            <CustomSmallHeadingAndText
                                // eslint-disable-next-line spire/avoid-dynamic-translate
                                heading={translate("ORDER #")}
                                text={order.erpOrderNumber !== "" ? order.erpOrderNumber : order.webOrderNumber}
                                extendedStyles={styles.orderNumberHeadingAndText}
                            />
                        )}
                    </DataTableCell>
                    <DataTableCell
                        css={css`
                            width: 25%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            padding: 0 6px;
                        `}
                    >
                        <SmallHeadingAndText
                            heading={translate("FROM QUOTE")}
                            text={order.webOrderNumber !== "" ? order.webOrderNumber : "—"}
                            extendedStyles={
                                order.webOrderNumber !== ""
                                    ? { ...styles.fromQuoterHeadingAndText }
                                    : { ...styles.grayDash }
                            }
                        />
                    </DataTableCell>
                    <DataTableCell
                        css={css`
                            width: 15%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            padding: 0 6px;
                        `}
                    >
                        <SmallHeadingAndText
                            heading={translate("Items")}
                            text={order.properties?.orderLinesCount}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    </DataTableCell>
                    <DataTableCell
                        css={css`
                            width: 32%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            padding: 0 6px;
                        `}
                    >
                        <SmallHeadingAndText
                            heading={translate("Total")}
                            text={order.orderGrandTotalDisplay}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    </DataTableCell>
                    <DataTableCell
                        css={css`
                            width: 4%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            padding: 0 0;
                        `}
                    >
                        <OrderDetailsKebabMenu orderNumber={orderNumber} />
                    </DataTableCell>
                </StyledWrapper>
                <StyledWrapper {...styles.secondStyleWrapper}>
                    <DataTableCell
                        css={css`
                            width: 24%;
                            display: flex;
                            align-content: center;
                            justify-content: center;
                            min-height: 60px;
                            display: flex;
                            flex-direction: column;
                            padding: 0 6px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                        `}
                        data-test-selector="orderHistoryTable_tableCell_orderNumber"
                    >
                        <SmallHeadingAndText
                            heading={translate("ORDER DATE")}
                            text={
                                order.orderDate
                                    ? getLocalizedDateTime({ dateTime: new Date(order.orderDate), language })
                                    : ""
                            }
                            extendedStyles={styles.orderDateHeadingAndText}
                        />
                    </DataTableCell>
                    <DataTableCell
                        css={css`
                            width: 22%;
                            display: flex;
                            align-content: center;
                            justify-content: center;
                            min-height: 60px;
                            display: flex;
                            flex-direction: column;
                            padding: 0 3px 0 6px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                        `}
                    >
                        {order.properties?.isMultipleShipment?.toLowerCase() === "true" ? (
                            <StyledWrapper {...styles.multipleDeliveryAndStatusWraaper}>
                                <Typography {...styles.multipleDeliveryHeading}>{translate("DELIVERY")}</Typography>
                                <Link
                                    {...styles.multipleLink}
                                    onClick={() => MultipleDeliveryClickHandler(orderNumber)}
                                >
                                    <StyledWrapper ref={getOrCreateDeliveryTextRef(orderNumber)}>
                                        <Typography>{translate("Multiple")}</Typography>
                                    </StyledWrapper>
                                </Link>

                                <MultipleDeliveryStatus
                                    parentRef={getOrCreateDeliveryTextRef(orderNumber)}
                                    onHandleClose={() => closeMultipleDeliveryModal()}
                                    orderNumber={orderNumber}
                                    isModalIsOpen={isDeliveryModalIsOpen === orderNumber}
                                    properties={order.properties}
                                    shipmentPackages={order.shipmentPackages}
                                />
                            </StyledWrapper>
                        ) : (
                            order.shipViaDescription && (
                                <SmallHeadingAndText
                                    heading={translate("DELIVERY")}
                                    text={translate("{0}", `${order.shipViaDescription}`)}
                                    extendedStyles={styles.deliveryrHeadingAndText}
                                />
                            )
                        )}
                    </DataTableCell>
                    <DataTableCell
                        css={css`
                            width: 19%;
                            display: flex;
                            align-content: center;
                            justify-content: center;
                            min-height: 60px;
                            display: flex;
                            flex-direction: column;
                            padding: 0 6px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                        `}
                    >
                        {order.properties.hasPod.toLocaleLowerCase() === "true" &&
                        order.properties?.isMultipleShipment?.toLowerCase() !== "true" ? (
                            <Button
                                variant="secondary"
                                {...styles.trackButton}
                                onClick={() => {
                                    loadPODDataHandler(
                                        order.id,
                                        order.properties,
                                        indexNumber,
                                        order.customerPO,
                                        false,
                                    );
                                }}
                            >
                                POD
                            </Button>
                        ) : order.properties.isWillCallPod?.toLocaleLowerCase() === "true" &&
                          order.properties.isWillCallPodExists?.toLocaleLowerCase() === "true" ? (
                            <Button
                                variant="secondary"
                                {...styles.trackButton}
                                onClick={() => {
                                    loadPODDataHandler(order.id, order.properties, indexNumber, order.customerPO, true);
                                }}
                            >
                                POD
                            </Button>
                        ) : (
                            <>
                                {order.properties?.trackingURLs &&
                                    order.properties?.isMultipleShipment?.toLowerCase() !== "true" && (
                                        <Button
                                            variant="secondary"
                                            {...styles.trackButton}
                                            onClick={() => {
                                                const trackingURLs = order.properties?.trackingURLs?.split(",");
                                                const firstUrl = trackingURLs?.length > 0 ? trackingURLs?.[0] : "";
                                                trackHandler(firstUrl);
                                            }}
                                        >
                                            {translate("Track")}
                                        </Button>
                                    )}
                            </>
                        )}
                    </DataTableCell>
                    <DataTableCell
                        css={css`
                            width: 35%;
                            display: flex;
                            align-content: center;
                            justify-content: center;
                            min-height: 60px;
                            display: flex;
                            flex-direction: column;
                            padding: 0 6px;
                            margin-top: 10px;
                        `}
                        data-test-selector="orderHistoryTable_tableCell_status"
                    >
                        {order?.status && order.properties?.isMultipleShipment?.toLowerCase() !== "true" && (
                            <StatusLableAndHeading
                                heading={translate("Status")}
                                isTrue={order.properties?.isMultipleShipment?.toLowerCase() === "true"}
                                text={order?.status}
                                extendedStyles={styles.orderNumberHeadingAndText}
                            />
                        )}
                    </DataTableCell>
                </StyledWrapper>
            </DataTableRow>
            {PODstate.isWillCallPod ? (
                <ProofOfDeliveryWillCallComponent
                    onHandleClose={closeModal}
                    modalIsOpen={PODstate.isModalOpen}
                    poNumber={PODstate.poNumber}
                />
            ) : (
                <ProofOfDeliveryComponent
                    onHandleClose={closeModal}
                    modalIsOpen={PODstate.isModalOpen}
                    poNumber={PODstate.poNumber}
                />
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummaryCardMobile);
